import { Injectable } from '@angular/core';
import { Observable, Subject, ReplaySubject } from 'rxjs';
import { filter, take, timeout } from 'rxjs/operators';
import { MoteEvent, MoteEventType } from './../models';

@Injectable({ providedIn: 'root' })
export class MoteEventService {
    private moteEventSubject = new Subject<MoteEvent>();

    constructor() {
    }

    public watchMoteEvents(): Observable<MoteEvent> {
        return this.moteEventSubject;
    }

    public watchEventType(type: MoteEventType): Observable<MoteEvent> {
        return this.moteEventSubject.pipe(filter(ev => ev.type == type));
    }

    public awaitEvent(type: MoteEventType, waitTimeout = 0): Promise<MoteEvent> {
        let watchEv = this.watchEventType(type);
        // Await one event and abort on timeout if requested
        let awaitOne = waitTimeout ? watchEv.pipe(take(1), timeout(waitTimeout)) : watchEv.pipe(take(1));
        // Return promise of one event
        return awaitOne.toPromise();
    }

    public emitMoteEvent(ev: MoteEvent) {
        // console.log("** Mote Event: " + ev.type, ev.mote ? ev.mote.title : "(No Mote Given)");
        this.moteEventSubject.next(ev);
    }
}
